// Generated by CoffeeScript 2.7.0
var ResponseMixin;

import ReactiveCalculationMixin from 'trunks/vue/share/components/fieldable/reactive_calculation.js';

export default ResponseMixin = {
  mixins: [ReactiveCalculationMixin],
  props: {
    responseable: Object,
    preventResponseCache: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      valid: true,
      saving: false
    };
  },
  created: function() {
    if (this.responseable.gid) {
      this.responseableGID = Skylark.Libs.GlobalID.locate(this.responseable.gid);
      if (!this.preventResponseCache) {
        return this.responseableCacheKey = [this.responseableGID.model_name.underscore(), this.responseableGID.model_id, 'draft'].join('_');
      }
    }
  },
  computed: {
    fields: function() {
      return this.responseable.fields;
    },
    allFields: function() {
      return _.chain(this.fields).map(function(field) {
        if (field.type === 'Field::Detail') {
          return field.children;
        } else {
          return field;
        }
      }).flatten().value();
    },
    hasCalculationFields: function() {
      return _.any(this.allFields, {
        type: 'Field::Calculation'
      });
    },
    logic_settings: function() {
      return this.responseable.logic_settings;
    }
  },
  watch: {
    valid: function(new_value) {
      return this.$emit('validChange', new_value);
    }
  },
  methods: {
    isValid: function() {
      if (!this.valid) {
        console.log('填写不合法');
        this.$refs.fieldsView.displayFirstError();
      }
      return this.valid;
    },
    validChange: function(valid) {
      return this.valid = valid;
    },
    cacheDraftEntries: function() {
      var ref, response;
      if (this.responseableCacheKey) {
        response = {
          entries: ((ref = this.$refs.fieldsView) != null ? ref.getDraftEntries() : void 0) || []
        };
        return localStorage.setItem(this.responseableCacheKey, JSON.stringify(response));
      }
    },
    beforeSave: function() {
      var response;
      if (this.saving) {
        return false;
      }
      if (!this.isValid()) {
        return false;
      }
      response = this._getResponse();
      if (!this.isValid()) {
        return false;
      }
      this.saving = true;
      return response;
    },
    _getResponse: function(vaidate_ignore = false) {
      return {
        response: {
          entries_attributes: this.$refs.fieldsView.getEntries(vaidate_ignore),
          id: this.response.id
        }
      };
    },
    _restoreDraftEntries: function() {
      var response, response_cache;
      response = this.responseableCacheKey && (response_cache = localStorage.getItem(this.responseableCacheKey)) ? JSON.parse(response_cache) : {
        entries: []
      };
      return this.response = new Skylark.App.Model.Response(response);
    },
    _bindCacheEvent: function() {
      // Chrome 已拦截 unload；pagehide 是替代事件，移动端也支持。
      window.addEventListener('pagehide', this.cacheDraftEntries, false);
      return document.addEventListener('page:before-unload', this.cacheDraftEntries, false);
    },
    _removeCache: function() {
      if (this.responseableCacheKey) {
        localStorage.removeItem(this.responseableCacheKey);
      }
      window.removeEventListener('pagehide', this.cacheDraftEntries, false);
      return document.removeEventListener('page:before-unload', this.cacheDraftEntries, false);
    },
    _positionError: function(error) {
      var e;
      try {
        return _.chain(error).keys().map((path) => {
          var detail_view, error_obj, field_view, group_view, msg;
          msg = error[path].join(',');
          error_obj = JSON.parse(path.replace(/.*fields\.(\w+)(:(\w+))?\.\w+/g, '{"field_id":"$1","group_id":"$3"}'));
          if (error_obj.group_id) {
            detail_view = _.find(this.$refs.fieldsView.fieldChildren, function(fieldView) {
              return fieldView.field.type === 'Field::Detail' && _.some(fieldView.field.fieldChildren, function(field) {
                return String(field.id) === String(error_obj.field_id);
              });
            });
            group_view = _.find(detail_view.$refs.detailGroupsRef, function(groupView) {
              return String(groupView.group.id) === String(error_obj.group_id);
            });
            field_view = _.find(group_view.groupedFieldList.fieldChildren, function(fieldView) {
              return String(fieldView.field.id) === String(error_obj.field_id);
            });
          } else {
            field_view = _.find(this.$refs.fieldsView.fieldChildren, function(fieldView) {
              return String(fieldView.field.id) === String(error_obj.field_id);
            });
          }
          field_view._resetValid();
          field_view._addError(msg);
          return field_view;
        }).first().value().focusToCurrent();
      } catch (error1) {
        e = error1;
        return console.log(e);
      }
    }
  }
};
